import { useShallow } from 'zustand/react/shallow';

import { CustomGizmoHelper } from 'app/modules/wallforming/components/scenes/camera-controls/CustomGizmoHelper';
import { CustomGizmoViewcube } from 'app/modules/wallforming/components/scenes/camera-controls/CustomGizmoViewcube';
import { CameraProjectionType } from 'app/modules/wallforming/components/scenes/camera-controls/types/cameraProjectionType';
import { cameraUpVectors } from 'app/modules/wallforming/components/scenes/camera-controls/utils/cameraUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const screenWidth = window.screen.width;

export const CameraOrientationCube = () => {
    const { mainCameraProjectionType, handleLockCameraControls } = usePlacementStore(
        useShallow((state) => ({
            mainCameraProjectionType: state.mainCameraProjectionType,
            handleLockCameraControls: state.handleLockCameraControls
        }))
    );

    return (
        <>
            {mainCameraProjectionType === CameraProjectionType.ORTHOGRAPHIC && (
                <CustomGizmoHelper
                    key={mainCameraProjectionType}
                    alignment="top-right"
                    margin={screenWidth >= 1920 ? [80, 80] : [60, 60]}
                    onUpdate={() => handleLockCameraControls(false)}
                >
                    <CustomGizmoViewcube
                        backgroundColor="#d8d9df"
                        faces={['Right', 'Left', 'Back', 'Front', 'Top', 'Bottom']}
                        font="bold 30px Inter, Arial, sans-serif"
                        hoverColor="#a4a5a8"
                        strokeColor="#000000"
                        textColor="#000000"
                        upVectors={cameraUpVectors}
                    />
                </CustomGizmoHelper>
            )}
        </>
    );
};
